import React from "react";
import { ReactEditor, HeaderViewer, CourseStatusChip, EditIcon, Grid, Typography, Divider, Button, SpellcheckIcon, MouseOverPopover, makeStyles } from "../../..";
import { EditorState, convertToRaw } from "draft-js";
import { Link } from "react-router-dom";
import PublishIcon from "@material-ui/icons/Publish";
var useStyles = makeStyles(function (theme) {
  return {
    flexCenter: {
      display: "flex",
      "align-items": "center"
    }
  };
});

var AcademyCourseLanguage = function AcademyCourseLanguage(props) {
  var classes = useStyles();

  var handlePreviewClicked = function handlePreviewClicked(code) {
    localStorage.setItem("central-sportmadness-manager-preview-code", code);
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: "16px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8,
    className: classes.flexCenter
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, props.language.name, /*#__PURE__*/React.createElement(EditIcon, {
    style: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return props.handleModalEditLanguage(props.tab);
    }
  })), /*#__PURE__*/React.createElement(CourseStatusChip, {
    status: props.language.status,
    style: {
      "margin-left": "20px"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center"
    }
  }, props.tab !== "es" && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    style: {
      margin: "8px",
      marginRight: "36px"
    },
    onClick: function onClick() {
      return props.handleModalDeleteLanguage(props.tab);
    }
  }, "Delete"), /*#__PURE__*/React.createElement(Link, {
    to: props.idCourse + "/" + props.tab + "/preview",
    target: "_blank",
    style: {
      textDecoration: "none"
    },
    onClick: function onClick() {
      return handlePreviewClicked(props.language.html);
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    style: {
      margin: "8px"
    }
  }, "Preview")), /*#__PURE__*/React.createElement(Button, {
    variant: props.language.edited ? "contained" : "outlined",
    disabled: props.language.edited ? false : true,
    color: "primary",
    onClick: function onClick() {
      return props.handleSaveLanguage(props.tab);
    },
    style: {
      margin: "8px"
    }
  }, props.language.edited ? "SAVE" : "SAVED"), /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: props.language.reviewed ? "REVIEWED" : "REVIEW"
  }, /*#__PURE__*/React.createElement(SpellcheckIcon, {
    disabled: props.language.reviewed,
    fontSize: "large",
    onClick: function onClick() {
      return props.handleReviewLanguage(props.tab);
    },
    style: {
      margin: "8px",
      color: !props.language.reviewed ? "#ffe082" : "#77ffb5"
    }
  })), props.status !== "building" && /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: props.language.status === "draft" ? "PUBLISH LANGUAGE" : "DRAFT LANGUAGE"
  }, /*#__PURE__*/React.createElement(PublishIcon, {
    fontSize: "large",
    onClick: function onClick() {
      return props.handleChangeStatusLanguage(props.tab, props.language.status);
    },
    style: {
      margin: "8px",
      color: props.language.status === "draft" ? "#ffe082" : props.language.status === "published" ? "#77ffb5" : "#ff0000"
    }
  }))))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.language.description, /*#__PURE__*/React.createElement(EditIcon, {
    style: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return props.handleModalEditLanguage(props.tab);
    }
  })))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "32px 0"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, " Content Page"), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(HeaderViewer, {
    content: props.language.editorState ? convertToRaw(props.language.editorState.getCurrentContent()) : EditorState.createEmpty()
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9
  }, /*#__PURE__*/React.createElement(ReactEditor, {
    handleEditorChange: props.handleEditorChangeLanguage,
    editorState: props.language.editorState
  })))];
};

export { AcademyCourseLanguage };